import React, { ReactNode } from 'react';
import { Card, CardSize } from './Card';

export interface DataCardEntry {
  label: string;
  entry: ReactNode;
}

export interface DataCardGroup {
  groupTitle: string;
  columnCount: number;
  groupData: DataCardEntry[];
}

export interface DataCardProps {
  title: string;
  description?: string;
  loading?: boolean;
  data: DataCardGroup[];
  size?: CardSize;
}

export const DataCard = ({ loading, data, title, description, size = 'sm' }: DataCardProps) => {
  return (
    <Card title={title} size={size} description={description}>
      <div className="flex flex-col ">
        {data?.map((group: DataCardGroup) => (
          <div
            key={group.groupTitle}
            className="flex flex-col border-b border-grey-400 dark:border-grey-800 last-of-type:border-b-0 "
          >
            <div className={`grid grid-cols-${group.columnCount} py-4  gap-5 `}>
              {group.groupData.map((entry: DataCardEntry) => (
                <div className="flex flex-col " key={entry.label}>
                  <span className="text-sm font-bold text-blue-800 dark:text-blue-500">
                    {entry.label}
                  </span>
                  <div>
                    {loading ? (
                      <div className="flex items-center w-full mt-1 animate-pulse">
                        <div className="w-full h-4 rounded bg-grey-400 dark:bg-grey-800"></div>
                      </div>
                    ) : (
                      <p className="break-words">{entry.entry}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
